import React from 'react';

const TechnologyPartnerships = () => {
  const technologies = [
    { name: 'AWS', logo: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg' },
    { name: 'Azure', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg' },
    { name: 'Google Cloud', logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg' },
    { name: 'OpenAI', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4d/OpenAI_Logo.svg' },
    { name: 'TensorFlow', logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg' },
    { name: 'Docker', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4e/Docker_%28container_engine%29_logo.svg' }
  ];

  const stats = [
    { value: '8+', label: 'Technology Partners' },
    { value: '100%', label: 'Industry-Relevant' },
    { value: 'Latest', label: 'Tech Stack' },
    { value: '24/7', label: 'Learning Access' }
  ];

  return (
    <section className="relative py-20 px-4 bg-white">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-4" style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}>
            Our Technology Partnerships
          </h2>
          <p className="text-lg text-[#4B5563]">
            Learn with the industry's most trusted platforms and tools
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center p-6 rounded-xl bg-gradient-to-br from-[#F9FAFB] to-white border border-[#E5E7EB]">
              <div className="text-3xl font-bold text-[#2563EB] mb-1" style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}>
                {stat.value}
              </div>
              <div className="text-sm text-[#6B7280] font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Technology Logos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {technologies.map((tech, idx) => (
            <div 
              key={idx}
              className="flex items-center justify-center p-6 rounded-xl bg-[#F9FAFB] border border-[#E5E7EB] transition-all duration-300 hover:bg-white hover:border-[#2563EB] hover:shadow-lg group"
            >
              <img
                src={tech.logo}
                alt={tech.name}
                className="h-12 w-auto opacity-60 group-hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyPartnerships;
